
import PayrollIndex from './PayrollIndex';

const PayrollIndividualIndex = () => (
    <PayrollIndex />
);

export default PayrollIndividualIndex;
